export default __webpack_public_path__ + "static/media/Strangler's Gloves of the Firebringer.6441e163.jpg";